import React from "react";

function DoNotEnter() {

    return (
    
        <g id="do-not-enter">
            <iframe 
                src="https://giphy.com/embed/l4FGGn33ylgByQhdS" 
                width="470" 
                height="470" 
                frameBorder="0" 
                >
            </iframe>
        </g>

    )

}

export default DoNotEnter 

